import React, { Fragment, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import Goals from "./Goals";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import RequiredCourseSet from "./RequiredCourseSet";
import "../../admin/StudentProgress/StudentProgress.css";
import "./GoalCriteriaOrSetup.css";

const API_URL = process.env.REACT_APP_API_URL;

const OpenModal = ({ data, isOpen, closeHandler }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={closeHandler} centered>
        <ModalHeader>
          Required Course Set Mapping Uploaded Successfully!!!
        </ModalHeader>
        <ModalBody>
          <div style={{ padding: "10px" }}>
            {data && (
              <div style={{ padding: "10px", background: "#fcf8e3" }}>
                <h4>Upload Course Map Error</h4>
                {data?.error?.map((item, idx) => (
                  <div key={idx} style={{ color: "#607d8b", fontSize: "14px" }}>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="admin-ccplus-btn broadcast" onClick={closeHandler}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

const GoalCriteriaOrSetup = () => {
  let history = useHistory();
  const uploadCourseRef = useRef();
  const [uploadCourseFile, setUploadCourseFile] = useState();
  const [dataAfterFileUpload, setDataAfterFileUpload] = useState();
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [openModalAfterUpload, setOpenModalAfterUpload] = useState(false);
  const [hasSelectedUploadFile, setHasSelectedUploadFile] = useState(false);

  const uploadCourseHandler = () => {
    let file = uploadCourseRef.current.files[0];
    setUploadCourseFile(file);
    setHasSelectedUploadFile(Boolean(file));
  };

  const uploadFileHandler = () => {
    let formData = new FormData();
    formData.append("csvfilename", undefined);
    formData.append("csv_file", uploadCourseFile);
    fetch(`${API_URL}/api/v1/course/upload-file`, {
      method: "POST",
      headers: {
        "x-authorization": `Bearer ${localStorage.getItem("token")}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setDataAfterFileUpload(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (uploadCourseFile) {
      uploadFileHandler();
    }
  }, [uploadCourseFile]);

  const uploadCourse = () => {
    let obj = {
      school: user?.school_id,
      upload: dataAfterFileUpload?.message,
    };
    GetStudentService.uploadAfter(obj)
      .then((data) => {
        setDataAfterFileUpload(data.data);
        setOpenModalAfterUpload(true);
        uploadCourseRef.current.value = "";
        setUploadCourseFile(null);
        setHasSelectedUploadFile(false);
      })
      .catch(() => {});
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="admin-ccplus-page">
            <div className="admin-ccplus-header">
              <div>
                <h1 className="admin-ccplus-title">Goal Editor</h1>
                <p className="admin-ccplus-subtitle">
                  Manage goals, course sets, and mapping for student progress
                </p>
              </div>
            </div>

            <div className="school-it-ccplus-tools">
              <div className="school-it-ccplus-note">
                <p className="school-it-ccplus-note-title">
                  For Upload Course Map
                </p>
                <p className="school-it-ccplus-note-text">
                  To Upload Course map, first create a CSV file that should
                  contain required course set names in the first row and the
                  first column should be datasource name. All the course names
                  should be mapped accordingly. Once the CSV file has been
                  created, upload the file.
                </p>
              </div>

              <div className="school-it-ccplus-tool-card" style={{ width: "100%" }}>
                <p className="school-it-ccplus-tool-label">Map College Data</p>
                <button
                  type="button"
                  onClick={() => history.push("/school_it/mapcollege")}
                  className="admin-ccplus-btn primary toolbar"
                >
                  Map College Data
                </button>
              </div>

              <div className="school-it-ccplus-tool-row">
                <div className="school-it-ccplus-tool-card">
                  <p className="school-it-ccplus-tool-label">Map Goal Data</p>
                  <button
                    type="button"
                    onClick={() => history.push("/school_it/mapgoal")}
                    className="admin-ccplus-btn primary toolbar"
                  >
                    Map Goal Data
                  </button>
                </div>
                <div className="school-it-ccplus-tool-card">
                  <p className="school-it-ccplus-tool-label">Upload Course Map</p>
                  <div className="school-it-ccplus-upload">
                    <input
                      type="file"
                      ref={uploadCourseRef}
                      onChange={uploadCourseHandler}
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                    <button
                      type="button"
                      disabled={!hasSelectedUploadFile}
                      onClick={uploadCourse}
                      className="admin-ccplus-btn broadcast toolbar"
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="admin-ccplus-panels">
              <div className="admin-ccplus-panel">
                <Goals />
              </div>
              <div className="admin-ccplus-panel">
                <RequiredCourseSet />
              </div>
            </div>
          </div>

          {openModalAfterUpload && (
            <OpenModal
              data={dataAfterFileUpload}
              isOpen={openModalAfterUpload}
              closeHandler={() => {
                setOpenModalAfterUpload(false);
                history.push("/school_it/ccplus");
              }}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default GoalCriteriaOrSetup;
